var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tituloRelevancia,{tag:"component",staticClass:"cms-titulo",style:({
        color: _vm.cor,
        textAlign: _vm.alinhamento,
        fontSize: _vm.fontScale( _vm.larguraTela ),
        fontWeight: _vm.estilo
    }),domProps:{"innerHTML":_vm._s(_vm.titulo)}})}
var staticRenderFns = []

export { render, staticRenderFns }